import type { StaticImageData } from 'next/legacy/image';

import freeTrialImage from './assets/images/free-trial-1.png';
export interface FreeTrialBannerSectionDataProps {
  title: string;
  description: string;
  btnText: string;
  image: StaticImageData;
  gradient: string;
}

export default <FreeTrialBannerSectionDataProps>{
  image: freeTrialImage,
};
